module.exports = __webpack_public_path__ + "static/media/3.f6a6895d.JPG";